/* PerfectBaby — pb-cart-rec-atc.js · v1.2 · 2026-07-08
   Upsell „+“ = add-to-cart (first available variant) + in-place drawer refresh.
   v1.2: reopen via theme-drawer.open() (owns dialog lifecycle) — manual
   showModal() left the drawer in a state where ✕ close was dead.
   v1.1: sold-out detection. Isolated; theme cart JS untouched. */
(function () {
  'use strict';

  var SECTION_WRAP = '#shopify-section-cart-drawer-section';
  var productCache = {};
  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var isLt = document.documentElement.lang.toLowerCase().split('-')[0] === 'lt';
  function showAddError(card, message) {
    var status = card.querySelector('.pb-rec-error');
    if (!status) {
      status = document.createElement('p');
      status.className = 'pb-rec-error';
      status.setAttribute('role', 'alert');
      card.appendChild(status);
    }
    status.textContent = message + ' ';
    var link = document.createElement('a');
    link.href = routeRoot + 'cart';
    link.textContent = isLt ? 'Peržiūrėti krepšelį' : 'View cart';
    status.appendChild(link);
  }
  var reviewText = isLt ? 'Nepavyko patvirtinti pridėjimo. Prieš bandydami dar kartą patikrinkite krepšelį.' : 'We could not confirm the addition. Check your cart before trying again.';

  function handleFromCard(card) {
    var plus = card.querySelector('button, [class*="add"], [class*="plus"]');
    var href = (card.getAttribute && card.getAttribute('href')) || (plus && plus.getAttribute && plus.getAttribute('href')) || (card.querySelector('a[href*="/products/"]') && card.querySelector('a[href*="/products/"]').getAttribute('href')) || (card.closest('a') && card.closest('a').getAttribute('href')) || '';
    var m = href.match(/\/products\/([^?\/#]+)/);
    return m ? m[1] : null;
  }

  async function getProduct(handle) {
    if (!handle) return null;
    if (productCache[handle]) return productCache[handle];
    try {
      var p = await fetch('/products/' + handle + '.js').then(function (r) { return r.json(); });
      productCache[handle] = p;
      return p;
    } catch (e) { return null; }
  }

  async function markSoldOut(root) {
    var cards = (root || document).querySelectorAll('.pb-cart-rec__card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.dataset.pbSoCheck === '1') continue;
      card.dataset.pbSoCheck = '1';
      var p = await getProduct(handleFromCard(card));
      if (p && p.available === false) {
        card.dataset.pbSoldout = '1';
        if (!card.querySelector('.pb-rec-soldout')) {
          var b = document.createElement('span');
          b.className = 'pb-rec-soldout';
          b.textContent = 'Sold out';
          card.appendChild(b);
        }
      }
    }
  }

  async function refreshCartSection() {
    try {
      var res = await fetch(window.location.pathname + '?section_id=cart-drawer-section', { headers: { 'Accept': 'text/html' } });
      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector(SECTION_WRAP) || doc.body;
      var cur = document.querySelector(SECTION_WRAP);
      if (fresh && cur) {
        var td = cur.querySelector('theme-drawer');
        var wasOpen = td ? td.hasAttribute('open') : !!cur.querySelector('dialog[open]');
        if (wasOpen && td && typeof td.close === 'function') { try { td.close(); } catch (e) {} }
        cur.innerHTML = fresh.innerHTML;
        if (wasOpen) {
          var ntd = cur.querySelector('theme-drawer');
          if (ntd && typeof ntd.open === 'function') { ntd.open(); }
          else { var d = cur.querySelector('dialog'); if (d && !d.open && d.showModal) d.showModal(); }
        }
      }
      var c = await fetch('/cart.js').then(function (r) { return r.json(); });
      var b = document.querySelector('#cart-bubble-text, .cart-bubble__text');
      if (b) b.textContent = c.item_count;
      markSoldOut(document);
    } catch (e) { /* silent */ }
  }

  document.addEventListener('click', async function (e) {
    var plus = e.target.closest && e.target.closest('.pb-cart-rec__card button, .pb-cart-rec__card [class*="add"], .pb-cart-rec__card [class*="plus"]');
    if (!plus) return;
    var card = plus.closest('.pb-cart-rec__card');
    if (!card) return;
    e.preventDefault();
    e.stopPropagation();
    if (card.dataset.pbSoldout === '1') return;
    if (card.dataset.pbAtcBusy === '1') return;
    card.dataset.pbAtcBusy = '1';
    plus.style.opacity = '.45';
    var addErrorMessage = reviewText;
    try {
      var vid = card.dataset.variantId || plus.dataset.variantId;
      if (!vid) {
        var p = await getProduct(handleFromCard(card));
        if (p) {
          var v = null;
          for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available) { v = p.variants[i]; break; } }
          if (!v) { addErrorMessage = isLt ? 'Šiuo metu prekė išparduota.' : 'This item is currently sold out.'; throw new Error(addErrorMessage); }
          if (v) vid = v.id;
        }
      }
      if (vid) {
        var response = await fetch(routeRoot + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: Number(vid), quantity: 1 }) });
        if (!response.ok) {
          var failure = await response.json().catch(function () { return {}; });
          addErrorMessage = typeof failure.description === 'string' ? failure.description : reviewText;
          throw new Error(addErrorMessage);
        }
        await refreshCartSection();
      } else {
        throw new Error(reviewText);
      }
    } catch (err) { showAddError(card, addErrorMessage); }
    card.dataset.pbAtcBusy = '';
    plus.style.opacity = '';
  }, true);

  function boot() { markSoldOut(document); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('cart-icon, [class*="cart-icon"]')) { setTimeout(function(){ markSoldOut(document); }, 600); }
  }, true);
})();
